<div class="container-fluid mb-5 padding-0">
  <div class="conversation-container">
    <!-- Tab Navigation based on project-interaction-settings-home -->
    <div class="ltms-tabs lato-bold-dark">
      <div class="ltms-tab" *ngIf="tabVisblity.general" [ngClass]="{ 'ltms-active-tab': activeTab === 'general' }"
        (click)="toggleTab('general')">
        General
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.ageing" [ngClass]="{ 'ltms-active-tab': activeTab === 'ageing' }"
        (click)="toggleTab('ageing')">
        Ageing Calculations
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.rules" [ngClass]="{ 'ltms-active-tab': activeTab === 'rules' }"
        (click)="toggleTab('rules')">
        Rules Setup
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.summary" [ngClass]="{ 'ltms-active-tab': activeTab === 'summary' }"
        (click)="toggleTab('summary')">
        Action Summary
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.inbox" [ngClass]="{ 'ltms-active-tab': activeTab === 'inbox' }"
        (click)="toggleTab('inbox')">
        Inbox
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.categories" [ngClass]="{ 'ltms-active-tab': activeTab === 'categories' }"
        (click)="toggleTab('categories')">
        Categories
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.status" [ngClass]="{ 'ltms-active-tab': activeTab === 'status' }"
        (click)="toggleTab('status')">
        Status
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.workflows" [ngClass]="{ 'ltms-active-tab': activeTab === 'workflows' }"
        (click)="toggleTab('workflows')">
        Workflows
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity['data-fields']"
        [ngClass]="{ 'ltms-active-tab': activeTab === 'data-fields' }" (click)="toggleTab('data-fields')">
        Data Fields
      </div>
    </div>


    <!-- Tab Content Areas -->
    <div class="tab-content-container mt-3">
      <!-- Categories Tab Content -->
      <div *ngIf="activeTab === 'categories' && tabVisblity.categories" class="tab-content-section">
        <app-litmus-action-categories [readonly]="!isUserHasWriteAccess"></app-litmus-action-categories>
      </div>

      <!-- Status Tab Content -->
      <div *ngIf="activeTab === 'status' && tabVisblity.status" class="tab-content-section">
        <app-litmus-action-status [readonly]="!isUserHasWriteAccess"></app-litmus-action-status>
      </div>

      <!-- Workflows Tab Content -->
      <div *ngIf="activeTab === 'workflows' && tabVisblity.workflows" class="tab-content-section">
        <app-litmus-action-workflows [readonly]="!isUserHasWriteAccess"></app-litmus-action-workflows>
      </div>

      <!-- Data Fields Tab Content -->
      <div *ngIf="activeTab === 'data-fields' && tabVisblity['data-fields']" class="tab-content-section">
        <app-litmus-action-data-fields [readonly]="!isUserHasWriteAccess"></app-litmus-action-data-fields>
      </div>

      <!-- General Tab Content -->
      <div *ngIf="activeTab === 'general' && tabVisblity.general" class="tab-content-section">
        <app-litmus-action-general [readonly]="!isUserHasWriteAccess"></app-litmus-action-general>
      </div>

      <!-- Ageing Calculations Tab Content -->
      <div *ngIf="activeTab === 'ageing' && tabVisblity.ageing" class="tab-content-section">
        <app-litmus-action-ageing [readonly]="!isUserHasWriteAccess"></app-litmus-action-ageing>
      </div>

      <!-- Rules Setup Tab Content -->
      <div *ngIf="activeTab === 'rules' && tabVisblity.rules" class="tab-content-section">
        <app-litmus-action-rules [readonly]="!isUserHasWriteAccess"></app-litmus-action-rules>
      </div>

      <!-- Action Summary Tab Content -->
      <div *ngIf="activeTab === 'summary' && tabVisblity.summary" class="tab-content-section">
        <app-litmus-action-summary [readonly]="!isUserHasWriteAccess"></app-litmus-action-summary>
      </div>

      <!-- Inbox Tab Content -->
      <div *ngIf="activeTab === 'inbox' && tabVisblity.inbox" class="tab-content-section">
        <app-litmus-action-inbox [readonly]="!isUserHasWriteAccess"></app-litmus-action-inbox>
      </div>
    </div>

    <!-- <div class="tab-content-container mt-3" *ngIf="!configurationLoaded">
      <app-ltms-loader></app-ltms-loader>
    </div> -->
  </div>
</div>